<template>
  <div>
    <v-divider></v-divider>
    <button @click="showPicker" text small>Divider style:</button>
    <div class="pa-3">
      <div class="divider-items">
        <div
          v-for="divider in dividers"
          :key="divider.type"
          class="divider-item"
          :class="
            block.config.style.dividerType === divider.type ? 'selected' : ''
          "
          @click="selectDivider(divider.type)"
        >
          <img
            :src="
              'https://cdn.landly.page/images/divider-previews/' +
              divider.type +
              '.png'
            "
            style="width: 100%; height: 100%"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import projectMixin from "../project-mixin";

export const dividers = [
  {
    type: "DIVIDER0",
  },
  {
    type: "DIVIDER5",
  },
  {
    type: "DIVIDER9",
  },
  {
    type: "DIVIDER10",
  },
  {
    type: "DIVIDER11",
  },
  {
    type: "DIVIDER12",
  },
  {
    type: "DIVIDER4",
  },
  {
    type: "DIVIDER14",
  },
  {
    type: "DIVIDER15",
  },
  { type: "DIVIDER16" },
  { type: "DIVIDER17" },
  { type: "DIVIDER18" },
];

export default {
  mixins: [projectMixin],
  props: ["block", "on"],
  data() {
    return {
      visible: false,
      x: 0,
      y: 0,
      dividers,
    };
  },
  methods: {
    showPicker(e) {
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.visible = true;
      });
    },
    selectDivider(dividerType) {
      this.UPDATE_BLOCK_PROP({
        id: this.block.id,
        prop: ["config", "style", "dividerType"],
        value: dividerType,
      });
    },
  },
  created() {},
};
</script>

<style scoped>
.divider-items {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.divider-item {
  width: 20%;
  height: 45px;
  background-color: white;
  padding: 5px;
  font-size: 14px;
  cursor: pointer;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 200ms all;
}
.divider-item:hover {
  box-shadow: rgba(130, 140, 190, 0.3) 0px 2px 4px 0px,
    rgba(40, 50, 100, 0.15) 0px 5px 15px 0px;
}
.divider-item.selected {
  border: 1px solid #292961;
}
.divider-item:hover {
  background-color: #efefef;
}
.divider-item img {
  width: 100%;
  height: 100%;
  background-size: contain;
}
</style>